import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Col, DatePicker, Input, message, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import aboutUsIcon from "../../../../assets/dental-inden/icons/aboutUsIcon.svg";
import { UndoOutlined } from "@ant-design/icons";

import {
  ageAssessmentBasePath,
  errorRequestHandel,
  getChildToothISO,
  prepareFormData,
  renderToothConditionColors,
  toothObservation,
} from "../../../../helper";
import { useLocation, useNavigate } from "react-router-dom";
import { _onToogleIsDirty } from "../../../../redux/actions/generalAction";
import CustomPrimaryButton from "../../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import CustomButtonWithIcon from "../../../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";
import ToothSquare from "../../../../dentail-indetifcation/components/d-reusable/tooth-square/ToothSquare";

import { dentalIcons } from "../../../../dentail-indetifcation/utils-icons/dentalIcons";
import CustomCard from "../../../../dentail-indetifcation/components/d-reusable/CustomCard";
import { assessmentIcons } from "../../../utils/assessmentIcons";
import {
  _onChangeSubjectRegistrationFormValues,
  _onResetCaseRegistrationForm,
  _onRsetCurrentCompletedTooth,
  _onSelectConditionForTeethForAgeAssessment,
  _onSelectTempTeethForAgeAssessment,
  _onSetCurrentCaseDetails,
} from "../../../../redux/actions/age-assessment/caseRegistrationAction";
import moment from "moment";
import {
  addByColaborator,
  onSubjectRegistrationForAgeAssessment,
} from "../../../../components/https/age-assessment-apis";
import CustomModal from "../../../components/modals/CustomModal";
import CustomDrawer from "../../../../dentail-indetifcation/components/d-reusable/CustomDrawer";
import CaseReport from "../details/child/CaseReport";
import { useSubscriptionGuard } from "../../../../hooks/subscription-hook/UseSubscriptionGuard";

const DentalExamination = () => {
  const location = useLocation();
  useSubscriptionGuard();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [caseInfo, setCaseInfo] = useState(false);
  const [isConductingNow, setIsConductingNow] = useState(false);
  const [data, setData] = useState(null);

  // Extract query parameters from the URL

  const dispatch = useDispatch();

  const teethChart = useSelector(
    (state) => state.ageAssessmentCase?.teethChart || []
  );
  const tempTeeth = useSelector(
    (state) => state.ageAssessmentCase?.tempTeeth || []
  );

  const subject = useSelector((state) => state.ageAssessmentCase?.subject);
  const subjectInformation = subject;
  let updateSubjectInformation = {
    ...subjectInformation,
    present_teeth:
      teethChart
        ?.filter((tooth) => tooth.condition_type === "present")
        .map((presentTooth) => presentTooth?.iso) || [],
    restored_teeth:
      teethChart
        ?.filter((tooth) => tooth.condition_type === "restored")
        .map((presentTooth) => presentTooth?.iso) || [],
    missing_teeth:
      teethChart
        ?.filter((tooth) => tooth.condition_type === "missing")
        .map((presentTooth) => presentTooth?.iso) || [],
    decayed_teeth:
      teethChart
        ?.filter((tooth) => tooth.condition_type === "decayed")
        .map((presentTooth) => presentTooth?.iso) || [],
  };

  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );

  const { metaData } = useSelector((state) => state.general);
  const [loading, setLoading] = useState(false);

  const [opgImage, setOpgImage] = useState(null);
  const [radiographs, setRadiographs] = useState([]);

  const [zoomImage, setZoomImage] = useState(false);

  // Split teeth into quadrants (assuming teeth array has 32 items)
  const firstQuadrant = metaData.teeth.slice(0, 8); // Teeth 18-11
  const secondQuadrant = metaData.teeth.slice(8, 16); // Teeth 21-28
  const thirdQuadrant = metaData.teeth.slice(24, 32).reverse(); // Teeth 48-41
  const fourthQuadrant = metaData.teeth.slice(16, 24).reverse(); // Teeth 31-38

  const toothConditions = [
    {
      heading: "Missing Tooth (M-T)",
      color: "#E53935",
      type: "missing",
      identifier: "M-T",

      isDisabled: false,
    },

    {
      heading: "Restored Tooth (R-T)",
      color: "#1E5BDB",
      type: "restored",
      identifier: "R-T",

      isDisabled: false,
    },
    {
      heading: "Present Tooth (P-T)",
      color: "#FB6A0A",
      type: "present",
      identifier: "P-T",

      isDisabled: false,
    },
    {
      heading: "Decayed Tooth (D-T)",
      color: "#7A3E10",
      type: "decayed",
      identifier: "D-T",

      isDisabled: false,
    },
  ];

  const handleToogleTeethSelection = (tooth_id, index) => {
    dispatch(_onSelectTempTeethForAgeAssessment(tooth_id));
  };
  const getToothDetails = (tooth_id) => {
    return teethChart.find((mark) => mark.tooth_id === tooth_id);
  };

  const handleOpgUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setOpgImage({
        file, // Store actual file
        preview: URL.createObjectURL(file), // Store preview for UI
      });
    }
  };

  // Handle multiple radiograph uploads
  const handleRadiographsUpload = (event) => {
    const files = Array.from(event.target.files);
    setRadiographs((prev) => [
      ...prev,
      ...files.map((file) => ({
        file, // Store actual file
        preview: URL.createObjectURL(file), // Store preview for UI
      })),
    ]);
  };

  // Remove image from radiographs
  const removeRadiograph = (index) => {
    setRadiographs((prev) => prev.filter((_, i) => i !== index));
  };
  const onRemoveOpgImage = () => {
    setOpgImage(null);
  };
  const onShowZoomImage = () => {
    setZoomImage(true);
  };

  const handleSaveAllRecord = async () => {
    const formData = prepareFormData({
      teethChart: teethChart,
      subject,
      opgImage,
      radiographs,
    });

    try {
      setLoading(true);
      const response = await onSubjectRegistrationForAgeAssessment({
        formData: formData,
      });
      if (response.status === 200) {
        const _collaborator = {
          project_id: response.data.data?.project_id,
          examiner_id: userdata?.id,
          role: "primary",
        };
        const responseCol = await addByColaborator({
          payload: _collaborator,
        });
        if (responseCol.status === 200) {
          setData(response.data.data);
          setIsConductingNow(true);
          setLoading(false);
        }
      }
    } catch (error) {
      errorRequestHandel({ error: error });
      setLoading(false);
    }
  };

  const onConductNow = () => {
    dispatch(_onSetCurrentCaseDetails(data));
    dispatch(_onResetCaseRegistrationForm());
    navigate(`${ageAssessmentBasePath}/cases/age-group`);
  };
  const onConductLater = () => {
    dispatch(_onResetCaseRegistrationForm());

    navigate(`${ageAssessmentBasePath}/cases`);
  };

  const removeQuadrantPrefix = (name) => {
    return name.replace(/^(Upper|Lower) (Left|Right) /, "");
  };

  const showResetButton = teethChart.some(
    (tooth) => tempTeeth.includes(tooth.id) && tooth.marked_completed
  );
  return (
    <div className="d-dental_record_container">
      <Row
        justify={"space-between"}
        gutter={[10, 16]}
        align={"top"}
        style={{ marginBottom: 10 }}
      >
        <Col></Col>
        <Col>
          <CustomPrimaryButton
            title="View Case Info"
            onClick={() => setCaseInfo(true)}
          />
        </Col>
      </Row>

      {/* <CustomCard> */}
      <div style={{ padding: "20px 0px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p className="dental_record_heading">
            Mark Tooth and Assign Conditions.
          </p>
          {showResetButton && (
            <Button
              icon={<UndoOutlined style={{ fontSize: 16 }} />}
              onClick={() => dispatch(_onRsetCurrentCompletedTooth())}
              style={{
                background: "rgba(229, 57, 53, 0.1)", // light red background
                color: "rgb(229, 57, 53)", // red text/icon
                border: "1px solid rgba(229, 57, 53, 0.3)", // faint border
                fontWeight: 500,
                fontSize: 14,
                display: "flex",
                alignItems: "center",
                gap: 6,
                borderRadius: 6, // softer pill look
                padding: "2px 10px",
                height: "auto",
              }}
            >
              Reset Selection
            </Button>
          )}
        </div>
        <Row gutter={[10, 10]} className="dental_record_quadrant_section">
          {[firstQuadrant, secondQuadrant, thirdQuadrant, fourthQuadrant].map(
            (quadrant, quadrantIndex) => (
              <Col md={12} key={quadrantIndex}>
                <div
                  className="dental_record_quadrant"
                  // style={{ background: "transparent", border: 0 }}
                >
                  <Row>
                    {quadrant.map((item, index) => {
                      const toothDetails = getToothDetails(item.id);
                      let isToothActive = toothDetails?.iso === item.iso;
                      const isUpperQuadrant =
                        quadrantIndex === 0 || quadrantIndex === 1; // 0=first, 1=second

                      return (
                        <Col md={3} key={index}>
                          <div
                            className="dental_record_singel_tooth"
                            style={{
                              background: tempTeeth.includes(item.id)
                                ? "#20C3FF2E"
                                : "transparent",
                              cursor: false ? "no-drop" : "pointer",
                              color: tempTeeth.includes(item.id)
                                ? "black"
                                : "black",
                              // border: "1px solid grey",
                              // borderRadius: 10,
                              // margin: "0 3px",
                              height: 145,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              flexDirection: "column",
                              textAlign: "center",
                              width: "100%",
                            }}
                            onClick={() => {
                              if (false) {
                                return;
                              }
                              handleToogleTeethSelection(
                                item.id,
                                quadrantIndex
                              );
                            }}
                          >
                            {!isUpperQuadrant && (
                              <div
                                className="dental_record_singel_tooth_type"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  height: 25,
                                  justifyContent: "flex-end",
                                  padding: 0,
                                }}
                              >
                                {toothDetails && (
                                  <p
                                    style={{
                                      color: renderToothConditionColors(
                                        toothDetails.condition_type
                                      ),
                                    }}
                                  >
                                    {toothDetails?.condition_identifier}
                                  </p>
                                )}
                              </div>
                            )}
                            {isUpperQuadrant && (
                              <small
                                style={{
                                  fontSize: 10,
                                  height: 30,
                                }}
                              >
                                {removeQuadrantPrefix(item.name)} {item.iso}
                              </small>
                            )}
                            <div
                              style={{
                                height: 70,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <ToothSquare
                                toothNumber={item.iso}
                                color={renderToothConditionColors(
                                  toothDetails?.condition_type || ""
                                )}
                                details={toothDetails}
                                isCompleted={toothDetails ?? false}
                              />
                            </div>

                            {isUpperQuadrant && (
                              <div
                                className="dental_record_singel_tooth_type"
                                style={{
                                  flexDirection: "column",
                                  height: 25,
                                }}
                              >
                                {toothDetails && (
                                  <p
                                    style={{
                                      color: renderToothConditionColors(
                                        toothDetails.condition_type
                                      ),
                                      height: 20,
                                    }}
                                  >
                                    {toothDetails?.condition_identifier}
                                  </p>
                                )}
                              </div>
                            )}

                            {!isUpperQuadrant && (
                              <div
                                style={{
                                  height: 30,
                                  display: "flex",
                                  alignItems: "flex-end",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <small
                                  style={{
                                    fontSize: 10,
                                  }}
                                >
                                  {removeQuadrantPrefix(item.name)} {item.iso}
                                </small>
                              </div>
                            )}
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Col>
            )
          )}
        </Row>

        <Row gutter={[10, 20]}>
          {toothConditions.map((condition, index) => {
            return (
              <Col md={6} key={index}>
                <div
                  className="dental_examination_selection_type"
                  onClick={() =>
                    dispatch(
                      _onSelectConditionForTeethForAgeAssessment(condition)
                    )
                  }
                >
                  <p
                    className="condition_heading"
                    style={{ color: condition.color }}
                  >
                    {condition.heading}
                  </p>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      {/* </CustomCard> */}
      <br />
      <CustomCard>
        <div style={{ padding: 20 }}>
          <span>Add Dental Observation</span>
          <img
            src={aboutUsIcon}
            style={{ height: 15, margin: "10px 10px", cursor: "pointer" }}
            onClick={() => setIsOpen(true)}
          />
          <Input.TextArea
            style={{ height: 100 }}
            placeholder="Write Here"
            className="form_basic_text_area"
            value={subject?.dental_observation}
            onChange={(e) =>
              dispatch(
                _onChangeSubjectRegistrationFormValues(
                  "dental_observation",
                  e.target.value
                )
              )
            }
          />
        </div>
      </CustomCard>
      <br />

      <CustomCard>
        <div style={{ padding: 20 }}>
          <span>Upload</span>
          <div style={{ display: "flex", gap: 20 }}>
            {/* Single Upload */}
            <div
              className="upload_container"
              onClick={() => document.getElementById("opgInput").click()}
            >
              <img
                src={opgImage?.preview || assessmentIcons.opg}
                alt="OPG/PA"
                style={{
                  objectFit: "contain",
                  width: opgImage != null ? "100%" : 30,
                  height: opgImage != null ? "100%" : 30,
                }}
                onClick={(event) => event.stopPropagation()}
              />
              {opgImage == null && <p>Click to upload OPG/PA</p>}

              <input
                type="file"
                id="opgInput"
                accept="image/*"
                onChange={handleOpgUpload}
                style={{ display: "none" }}
              />
              {opgImage !== null && (
                <div className="opg_actions">
                  <img
                    src={assessmentIcons.remove}
                    className="remove_icon"
                    onClick={(event) => {
                      event.stopPropagation(); // Prevents parent click event
                      onRemoveOpgImage();
                    }}
                  />
                  <img
                    src={assessmentIcons.zoom}
                    className="xoom_icon"
                    onClick={(event) => {
                      event.stopPropagation(); // Prevents parent click event
                      onShowZoomImage();
                    }}
                  />
                </div>
              )}
            </div>
            <div
              className={
                radiographs?.length
                  ? "upload_container_multitple"
                  : "upload_container"
              }
              style={{ width: "100%" }}
              onClick={() =>
                document.getElementById("radiographsInput").click()
              }
            >
              {radiographs.length > 0 ? (
                <div className="radiographs_grid">
                  {radiographs.map((src, index) => (
                    <div key={index} className="radiograph_item">
                      <div
                        className="radio_graph_action"
                        onClick={(event) => {
                          event.stopPropagation(); // Prevents opening the file picker
                          removeRadiograph(index);
                        }}
                      >
                        <img
                          src={assessmentIcons.remove}
                          height={20}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <img
                        src={src?.preview}
                        alt={`Radiograph ${index + 1}`}
                        className="radiograph_image"
                        onClick={(event) => event.stopPropagation()}
                      />
                    </div>
                  ))}

                  {/* Add More Button (visible when images exist) */}
                  <div className="radiograph_item add_more_button">
                    <img src={assessmentIcons.addfill} />
                  </div>
                </div>
              ) : (
                // Ensures text is clickable when no images exist
                <div style={{ textAlign: "center", padding: "10px 0" }}>
                  <img src={assessmentIcons.opg} alt="Additional Radiographs" />
                  <p>Click to upload Additional Radiographs</p>
                </div>
              )}
              <input
                type="file"
                id="radiographsInput"
                accept="image/*"
                multiple
                onChange={handleRadiographsUpload}
                style={{ display: "none" }}
              />
            </div>
          </div>
        </div>
      </CustomCard>
      <br />
      <CustomCard>
        <div style={{ padding: 20, flexDirection: "column", display: "flex" }}>
          <span>Date of Radiograph *</span>
          <DatePicker
            style={{ width: 300, margin: "10px 0px" }}
            value={moment(subject?.radiograph_date)}
            onChange={(event) =>
              dispatch(
                _onChangeSubjectRegistrationFormValues("radiograph_date", event)
              )
            }
            disabledDate={(current) =>
              current && current > moment().endOf("day")
            } // Disable future dates
            clearIcon={false}
          />
        </div>
      </CustomCard>
      <br />
      <br />

      <CustomPrimaryButton
        title="Save All"
        onClick={handleSaveAllRecord}
        isLoading={loading}
      />

      <CustomModal open={isOpen} onCancel={() => setIsOpen(false)} width={700}>
        <div className="exam_observation_section">
          <h4>Clinical Findings Affecting Dental Assessment:</h4>

          <ul>
            {toothObservation.map((condition, index) => (
              <li key={index}>{condition.title}</li>
            ))}
          </ul>
        </div>
      </CustomModal>

      <CustomDrawer
        width={450}
        open={caseInfo}
        onClose={() => setCaseInfo(false)}
        title="Details"
      >
        <CaseReport caseDetails={updateSubjectInformation} isDirty={true} />
      </CustomDrawer>

      <CustomModal
        open={isConductingNow}
        onCancel={() => setIsConductingNow(false)}
        closeIcon={true}
      >
        <div className="conducting_exam_section">
          <div>
            <img src={assessmentIcons.conductingIcon} />
          </div>
          <h4>Case Submitted Successfully</h4>
          <p>You can start the analysis now or return later to complete it.</p>
          <div className="conduct_exam_actions">
            <CustomButtonWithIcon
              title="Return Later"
              width={200}
              onClick={onConductLater}
            />
            <CustomPrimaryButton
              title="Start Now"
              width={200}
              onClick={onConductNow}
            />
          </div>
        </div>
      </CustomModal>

      <br />

      {zoomImage && (
        <div className="zoom_image overlay">
          <div className="zoom_full_screen_image">
            <div className="close_zoom">
              <img
                src={dentalIcons.closeModal}
                onClick={() => setZoomImage(false)}
              />
            </div>
            <img src={opgImage?.preview} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DentalExamination;
